/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * New ETag of the module submission
 */
export type AttachmentDeleteResponseEtag = string | null;
